import { FaChevronLeft } from 'react-icons/fa';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { Button } from 'react-bootstrap';
import React from 'react';

var MissingCreditInfo = function MissingCreditInfo(props) {
  var fields = props.fields,
      _props$setShowMissCre = props.setShowMissCreditInfo,
      setShowMissCreditInfo = _props$setShowMissCre === void 0 ? function () {
    return "";
  } : _props$setShowMissCre;
  var logo = fields.logo,
      onPressAction = fields.onPressAction,
      contactButtonLink = fields.contactButtonLink,
      header = fields.header,
      description = fields.description,
      contactButtonLabel = fields.contactButtonLabel,
      legalInfoCopy = fields.legalInfoCopy;

  var redirectToLink = function redirectToLink(e) {
    e.preventDefault();
    window.location.href = contactButtonLink.value;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit-old"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit-old__header"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "cb-account-miss-credit-old__back",
    onClick: function onClick(e) {
      e.preventDefault();
      setShowMissCreditInfo(false);
    }
  }, /*#__PURE__*/React.createElement(FaChevronLeft, null)), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit-old__logo"
  }, /*#__PURE__*/React.createElement(Image, {
    field: logo
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit-old__card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit-old__card__header"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    field: {
      value: header ? header.value : ""
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit-old__card__body"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: description,
    tag: "p"
  }), contactButtonLink && contactButtonLink.value !== "" && /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    onClick: redirectToLink
  }, contactButtonLabel.value))), /*#__PURE__*/React.createElement("div", {
    className: "cb-account-miss-credit-old__terms"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: legalInfoCopy,
    tag: "p"
  })));
};

export default MissingCreditInfo;